<template>
    <section class="w-full bg-white px-4 py-6 mb-4 wrapper-bar-donught">
        <div class="flex justify-center md:justify-start items-center pb-5">
            <h1 class="md:text-xl">Employee On Break</h1>
        </div>
        <div class="overflow-y-auto max-h-[475px]">
            <table class="w-full pb-4 mt-1 min-w-max">
                <thead class="text-gray-400 border-b border-gray-200">
                    <tr>
                        <th class="text-sm text-left">Profile</th>
                        <!-- <th class="text-sm text-left">Status</th> -->
                    </tr>
                </thead>
                <tbody v-if="!isLoading">
                    <tr class="border-b h-max" v-for="(empOnBreak, index) in empOnBreak" :key="index">
                        <td class="p-3 text-sm">
                            <div class="flex flex-row items-center gap-x-2">
                                <div class="flex items-center justify-center w-12 h-12 rounded-full shadow-md bg-zinc-400">
                                    <h2 class="text-white text-md">
                                        {{ avatarEmployee(empOnBreak.emp_id.emp_fullname) }}
                                    </h2>
                                </div>
                                <div class="flex flex-col">
                                    <p class="text-sm text-blue-500">
                                        {{ empOnBreak.emp_id?.emp_fullname }}
                                    </p>
                                    <p class="text-sm text-gray-400">
                                        {{ empOnBreak.emp_id?.emp_depid?.dep_name }}
                                    </p>
                                </div>
                            </div>
                        </td>
                        <!-- <td class="text-sm">On Break</td> -->
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td>Loading ...</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>
  
<script>

export default {
    name: "OnBreakMonitor",
    props: {
        empOnBreak: {
            type: Array,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            onBreak: this.empOnBreak,
        }
    },
    methods: {
        avatarEmployee(employeeFullname) {
            return (
                employeeFullname.substr(0, 1) +
                employeeFullname.substr(employeeFullname.indexOf(" ") + 1, 1)
            );
        },
    },
};
</script>
  
<style scoped>
.wrapper-bar-donught {
    height: 550px;
}

p {
    font-size: 14px;
    margin-top: 4px;
}
</style>
  